// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chart-card-title {
  font-size: 18px;
  font-weight: 800;
  color: #0f172a;
  margin: 0;
}

.legend-dot {
  width: 26px;
  height: 12px;
  border-radius: 3px;
  display: inline-block;
}

.legend-outline-box {
  width: 46px;
  height: 18px;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  background-color: #fcfcfc;
}

.chart-render-container {
  width: 100%;
  min-height: 240px;
  position: relative;
}

/* Absolute peak custom tooltip marker overlay for curved spline chart */
.absolute-peak-tooltip {
  position: absolute;
  left: 47.7%;
  top: -8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  pointer-events: none;
  z-index: 10;
}

.peak-tooltip-pill {
  background-color: #2f3299;
  color: #ffffff;
  font-size: 10px;
  font-weight: 800;
  padding: 3px 9px;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(47, 50, 153, 0.35);
  margin-bottom: 2px;
}

.peak-vertical-line {
  width: 1px;
  height: 154px;
  border-left: 1.5px dashed #2f3299;
  margin-bottom: -168px;
  opacity: 0.85;
}

.peak-reference-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #ffffff;
  border: 3.5px solid #2f3299;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.15);
}
`, "",{"version":3,"sources":["webpack://./src/components/dashboard/CurvedAreaCard.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,wEAAwE;AACxE;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,6CAA6C;EAC7C,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,iCAAiC;EACjC,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;EAC3B,uCAAuC;AACzC","sourcesContent":[".chart-card-title {\n  font-size: 18px;\n  font-weight: 800;\n  color: #0f172a;\n  margin: 0;\n}\n\n.legend-dot {\n  width: 26px;\n  height: 12px;\n  border-radius: 3px;\n  display: inline-block;\n}\n\n.legend-outline-box {\n  width: 46px;\n  height: 18px;\n  border: 1px solid #e2e8f0;\n  border-radius: 4px;\n  background-color: #fcfcfc;\n}\n\n.chart-render-container {\n  width: 100%;\n  min-height: 240px;\n  position: relative;\n}\n\n/* Absolute peak custom tooltip marker overlay for curved spline chart */\n.absolute-peak-tooltip {\n  position: absolute;\n  left: 47.7%;\n  top: -8px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  pointer-events: none;\n  z-index: 10;\n}\n\n.peak-tooltip-pill {\n  background-color: #2f3299;\n  color: #ffffff;\n  font-size: 10px;\n  font-weight: 800;\n  padding: 3px 9px;\n  border-radius: 12px;\n  box-shadow: 0 4px 8px rgba(47, 50, 153, 0.35);\n  margin-bottom: 2px;\n}\n\n.peak-vertical-line {\n  width: 1px;\n  height: 154px;\n  border-left: 1.5px dashed #2f3299;\n  margin-bottom: -168px;\n  opacity: 0.85;\n}\n\n.peak-reference-dot {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background-color: #ffffff;\n  border: 3.5px solid #2f3299;\n  box-shadow: 0 0 6px rgba(0, 0, 0, 0.15);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
